/**
 * returns the height of a hidden element
 *
 * @param $el
 * @returns {number}
 */
export const getHiddenElementHeight = $el => {
    let currentHeight = $el.style.height;
    const elStyles = window.getComputedStyle($el, null);
    if (elStyles.display === 'none'
        || elStyles.height === ('0px' || 0)
    ) {
        currentHeight = 0;
    }

    $el.style.height = 'auto';
    $el.style.display = 'block';
    const elHeight = $el.offsetHeight;
    $el.style.height = currentHeight;

    return elHeight;
};

/**
 * returns the correct transition end event name
 *
 * @returns {*}
 */
export const getTransitionEndEvent = () => {
    const $el = document.createElement('fakeelement');

    const transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };

    return Object.keys(transitions).reduce((event, transition) => {
        if ($el.style[transition] === undefined) {
            return event;
        }

        return transitions[transition];
    }, transitions.transition);
};
